import React, { useEffect, useState } from "react";
import axios from "axios";
import { useAuthStore } from "../../stores/authStore";

interface AwsOrderPrintViewProps {
  pedidoId: number;
  onClose: () => void;
  autoDownload?: boolean;
}

const F = (v: any) => {
  const n = Number(v);
  return isNaN(n)
    ? "0,00"
    : n.toLocaleString("pt-BR", { minimumFractionDigits: 2 });
};

const FC = (v: any) => {
  const n = Number(v);
  return isNaN(n)
    ? "R$ 0,00"
    : n.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
};

const FD = (d: string | null | undefined) => {
  if (!d) return "---";
  try {
    return new Date(d).toLocaleDateString("pt-BR");
  } catch {
    return "---";
  }
};

const T = [33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48];

const s = (o: any) => {
  const r: React.CSSProperties = {};
  for (const k of Object.keys(o)) (r as any)[k] = o[k];
  return r;
};

// ── Preview A4 (210x297mm) com box-sizing:border-box ──
const PedidoPreview: React.FC<{ data: any; modo: "interno" | "cliente" }> = ({
  data,
  modo,
}) => {
  const { pedido, produtos, totalItens, totalValor } = data;
  const nome = pedido.cliente_nome_full || pedido.cliente_nome || "---";

  return (
    <div
      id="pdf-print-area"
      style={s({
        fontFamily: "Arial, Helvetica, sans-serif",
        fontSize: "9pt",
        color: "#000",
        width: "210mm",
        background: "#fff",
        padding: "8mm 10mm",
        boxSizing: "border-box",
        margin: 0,
      })}
    >
      <div
        style={s({
          textAlign: "center",
          fontWeight: "bold",
          fontSize: "10pt",
          borderBottom: "1px solid #000",
          marginBottom: "3mm",
          paddingBottom: "2mm",
        })}
      >
        {modo === "cliente" ? "via do cliente" : "Via Interna"}
      </div>

      {/* CABEÇALHO */}
      <div
        style={s({
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderBottom: "2px solid #000",
          paddingBottom: "3mm",
          marginBottom: "3mm",
        })}
      >
        <div style={s({ display: "flex", alignItems: "center", gap: "3mm" })}>
          <img
            src="/Logo.webp"
            alt="Kadesh"
            style={s({ height: "14mm", width: "auto" })}
          />
          <div
            style={s({ fontSize: "8pt", fontWeight: "bold", lineHeight: 1.4 })}
          >
            KADESH CALÇADOS PROFISSIONAIS LTDA
            <div style={s({ fontWeight: "normal", fontSize: "6.5pt" })}>
              Rua Antônio Lourenço, 08 - Centro
            </div>
            <div style={s({ fontWeight: "normal", fontSize: "6.5pt" })}>
              Imbituva - PR - CEP 84430-000 Fone (42) 3436-8500
            </div>
          </div>
        </div>
        <table
          style={s({
            borderCollapse: "collapse",
            border: "1px solid #000",
            textAlign: "center",
          })}
        >
          <tbody>
            <tr>
              <th
                style={s({
                  border: "1px solid #000",
                  padding: "1mm 4mm",
                  background: "#f0f0f0",
                  fontSize: "7pt",
                })}
              >
                PEDIDO
              </th>
              <th
                style={s({
                  border: "1px solid #000",
                  padding: "1mm 4mm",
                  background: "#f0f0f0",
                  fontSize: "7pt",
                })}
              >
                PRODUCAO
              </th>
            </tr>
            <tr>
              <td
                style={s({
                  border: "1px solid #000",
                  padding: "2mm 4mm",
                  fontSize: "13pt",
                  fontWeight: "bold",
                })}
              >
                {pedido.id}
              </td>
              <td
                style={s({
                  border: "1px solid #000",
                  padding: "2mm 4mm",
                  fontSize: "13pt",
                  fontWeight: "bold",
                })}
              >
                ---
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* EMISSÃO / VENDEDOR */}
      <div
        style={s({
          border: "1px solid #aaa",
          padding: "2mm 4mm",
          marginBottom: "2mm",
          fontSize: "8pt",
          lineHeight: 1.6,
        })}
      >
        <div>
          <b>EMISSÃO:</b> {FD(pedido.data_emissao)} &nbsp; &nbsp;{" "}
          <b>OPERAÇÃO:</b> {pedido.operacao_fiscal || "---"}
        </div>
        <div>
          <b>VENDEDOR:</b> {pedido.vendedor || "---"}
        </div>
        <div style={s({ display: "flex", justifyContent: "space-between" })}>
          <span />
          <span>
            <b>COND.PGTO :</b> {pedido.condicao_pgto || "---"}
          </span>
        </div>
      </div>

      {/* CLIENTE */}
      <div
        style={s({
          border: "1px solid #aaa",
          padding: "2mm 4mm",
          marginBottom: "2mm",
          fontSize: "8pt",
          lineHeight: 1.6,
        })}
      >
        <div style={s({ display: "flex", justifyContent: "space-between" })}>
          <div>
            <b>CLIENTE:</b>{" "}
            <span style={s({ fontWeight: "bold" })}>{nome}</span>
          </div>
          <div style={s({ textDecoration: "underline", fontWeight: "bold" })}>
            {pedido.segmento_nome || ""}
          </div>
        </div>
        <div>
          <b>CNPJ :</b> {pedido.DOCUMENTO || ""} &nbsp; <b>INC.EST</b> &nbsp;
          &nbsp; <b>{pedido.cidade || pedido.CIDADE || ""}</b>/
          {pedido.estado || pedido.ESTADO || ""}
        </div>
        <div>
          <b>ENDERECO :</b> {pedido.ENDERECO || ""}
          {pedido.NUMERO ? ", N° " + pedido.NUMERO : ""}
        </div>
        <div style={s({ display: "flex", justifyContent: "space-between" })}>
          <span>
            <b>FONE:</b> {pedido.TELEFONE || ""}
          </span>
          <span>
            <b>CEP:</b> {pedido.CEP || ""}
          </span>
        </div>
      </div>

      {/* TABELA */}
      <table
        style={s({
          width: "100%",
          borderCollapse: "collapse",
          fontSize: "7.5pt",
          marginTop: "1mm",
        })}
      >
        <thead>
          <tr>
            <th
              style={s({
                borderTop: "2px solid #000",
                borderBottom: "2px solid #000",
                padding: "1.5mm 1mm",
                width: "10mm",
              })}
            />
            <th
              style={s({
                borderTop: "2px solid #000",
                borderBottom: "2px solid #000",
                padding: "1.5mm 1mm",
                textAlign: "left",
                background: "#f5f5f5",
                width: "8mm",
              })}
            >
              ITEM
            </th>
            <th
              style={s({
                borderTop: "2px solid #000",
                borderBottom: "2px solid #000",
                padding: "1.5mm 1mm",
                textAlign: "left",
                background: "#f5f5f5",
                width: "22mm",
              })}
            >
              REF
            </th>
            <th
              style={s({
                borderTop: "2px solid #000",
                borderBottom: "2px solid #000",
                padding: "1.5mm 1mm",
                textAlign: "left",
                background: "#f5f5f5",
              })}
            >
              DESCRIÇÃO
            </th>
            <th
              style={s({
                borderTop: "2px solid #000",
                borderBottom: "2px solid #000",
                padding: "1.5mm 1mm",
                textAlign: "center",
                background: "#f5f5f5",
                width: "8mm",
              })}
            >
              UN
            </th>
            <th
              style={s({
                borderTop: "2px solid #000",
                borderBottom: "2px solid #000",
                padding: "1.5mm 1mm",
                textAlign: "center",
                background: "#f5f5f5",
                width: "8mm",
              })}
            >
              TAB
            </th>
            <th
              style={s({
                borderTop: "2px solid #000",
                borderBottom: "2px solid #000",
                padding: "1.5mm 1mm",
                textAlign: "center",
                background: "#f5f5f5",
                width: "10mm",
              })}
            >
              QTDE
            </th>
            <th
              style={s({
                borderTop: "2px solid #000",
                borderBottom: "2px solid #000",
                padding: "1.5mm 1mm",
                textAlign: "right",
                background: "#f5f5f5",
                width: "14mm",
              })}
            >
              PREÇO
            </th>
            <th
              style={s({
                borderTop: "2px solid #000",
                borderBottom: "2px solid #000",
                padding: "1.5mm 1mm",
                textAlign: "right",
                background: "#f5f5f5",
                width: "16mm",
              })}
            >
              $ TOTAL
            </th>
          </tr>
        </thead>
        <tbody>
          {(produtos || []).map((prod: any, i: number) => {
            const gm: Record<number, number> = {};
            for (const g of prod.grades || []) gm[g.tamanho] = g.quantidade;
            const qtd = Object.values(gm).reduce(
              (a: number, b: any) => a + Number(b),
              0,
            );
            const preco = Number(prod.preco_item) || 0;
            const valTotal = preco * qtd;
            const margem = Number(prod.margem) || 0;
            const mcPct = preco > 0 ? (margem / preco) * 100 : 0;

            return (
              <React.Fragment key={i}>
                <tr style={s({ borderTop: "1px solid #ddd" })}>
                  <td
                    rowSpan={2}
                    style={s({
                      width: "10mm",
                      textAlign: "center",
                      verticalAlign: "top",
                      padding: "1mm",
                    })}
                  >
                    {prod.img_base64 ? (
                      <img
                        src={prod.img_base64}
                        style={s({
                          maxWidth: "9mm",
                          maxHeight: "9mm",
                          display: "block",
                          margin: "0 auto",
                        })}
                        alt=""
                      />
                    ) : (
                      <div
                        style={s({
                          width: "9mm",
                          height: "9mm",
                          background: "#f0f0f0",
                          margin: "0 auto",
                        })}
                      />
                    )}
                  </td>
                  <td style={s({ padding: "1mm", verticalAlign: "top" })}>
                    {i + 1}
                  </td>
                  <td
                    style={s({
                      padding: "1mm",
                      verticalAlign: "top",
                      fontWeight: "bold",
                      whiteSpace: "nowrap",
                    })}
                  >
                    {prod.REFERENCIA}
                  </td>
                  <td style={s({ padding: "1mm", verticalAlign: "top" })}>
                    {prod.DESCRICAO}
                    {prod.opcional ? " | " + prod.opcional : ""}
                    {prod.CA ? "  CA:" + prod.CA : ""}
                  </td>
                  <td
                    style={s({
                      padding: "1mm",
                      textAlign: "center",
                      verticalAlign: "top",
                    })}
                  >
                    PR
                  </td>
                  <td
                    style={s({
                      padding: "1mm",
                      textAlign: "center",
                      verticalAlign: "top",
                    })}
                  >
                    R{prod.tabela_preco}
                  </td>
                  <td
                    style={s({
                      padding: "1mm",
                      textAlign: "center",
                      fontWeight: "bold",
                      verticalAlign: "top",
                    })}
                  >
                    {qtd}
                  </td>
                  <td
                    style={s({
                      padding: "1mm",
                      textAlign: "right",
                      verticalAlign: "top",
                    })}
                  >
                    {F(prod.preco_item)}
                  </td>
                  <td
                    style={s({
                      padding: "1mm",
                      textAlign: "right",
                      fontWeight: "bold",
                      verticalAlign: "top",
                    })}
                  >
                    {FC(valTotal)}
                  </td>
                </tr>
                <tr>
                  <td
                    colSpan={9}
                    style={s({
                      padding: "0 1mm 1.5mm 1mm",
                      verticalAlign: "top",
                    })}
                  >
                    <div
                      style={s({
                        display: "flex",
                        gap: "2mm",
                        alignItems: "flex-start",
                        flexWrap: "wrap",
                      })}
                    >
                      {modo === "interno" && (
                        <>
                          <div
                            style={s({
                              border: "1px solid #000",
                              display: "inline-flex",
                              flexDirection: "column",
                              width: "18mm",
                              flexShrink: 0,
                            })}
                          >
                            <div
                              style={s({
                                background: "#e5e7eb",
                                textAlign: "center",
                                fontSize: "6pt",
                                fontWeight: "bold",
                                borderBottom: "1px solid #000",
                                padding: "0.5mm 0",
                              })}
                            >
                              % - MC - R$
                            </div>
                            <div
                              style={s({
                                textAlign: "center",
                                fontSize: "7pt",
                                fontWeight: "bold",
                                padding: "1mm 0",
                              })}
                            >
                              {mcPct.toFixed(1)}%{" "}
                              <span
                                style={s({
                                  fontSize: "6.5pt",
                                  fontWeight: "normal",
                                  color: "#555",
                                })}
                              >
                                - {FC(preco)}
                              </span>
                            </div>
                          </div>
                          <div
                            style={s({
                              width: "1px",
                              background: "#ddd",
                              alignSelf: "stretch",
                            })}
                          />
                        </>
                      )}
                      <div
                        style={s({
                          display: "flex",
                          gap: "1mm",
                          flexWrap: "wrap",
                          flex: 1,
                        })}
                      >
                        {T.map((sz) => {
                          const v = Number(gm[sz]) || 0;
                          if (!v) return null;
                          return (
                            <div
                              key={sz}
                              style={s({
                                border: "1px solid #000",
                                display: "inline-flex",
                                flexDirection: "column",
                                width: "7mm",
                              })}
                            >
                              <div
                                style={s({
                                  background: "#e5e7eb",
                                  textAlign: "center",
                                  fontSize: "6pt",
                                  fontWeight: "bold",
                                  borderBottom: "1px solid #000",
                                  padding: "0.5mm 0",
                                })}
                              >
                                {sz}
                              </div>
                              <div
                                style={s({
                                  textAlign: "center",
                                  fontSize: "7pt",
                                  fontWeight: "bold",
                                  padding: "0.5mm 0",
                                })}
                              >
                                {v}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </td>
                </tr>
              </React.Fragment>
            );
          })}
          <tr>
            <td colSpan={9} style={s({ padding: "2mm 1mm" })}>
              <div
                style={s({
                  display: "flex",
                  gap: "10mm",
                  justifyContent: "flex-end",
                  borderTop: "2px solid #000",
                  paddingTop: "2mm",
                  fontSize: "8pt",
                })}
              >
                <div>
                  <div
                    style={s({
                      fontWeight: "bold",
                      borderBottom: "1px solid #555",
                    })}
                  >
                    Qtde
                  </div>
                  <div style={s({ textAlign: "center", fontWeight: "bold" })}>
                    {totalItens}
                  </div>
                </div>
                <div>
                  <div
                    style={s({
                      fontWeight: "bold",
                      borderBottom: "1px solid #555",
                    })}
                  >
                    Valor Total
                  </div>
                  <div style={s({ fontWeight: "bold" })}>{FC(totalValor)}</div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <div style={s({ marginTop: "3mm", fontSize: "7pt" })}>
        <div style={s({ fontWeight: "bold", marginBottom: "1mm" })}>
          Observações
        </div>
        <div style={s({ whiteSpace: "pre-wrap" })}>{pedido.obs || ""}</div>
      </div>
    </div>
  );
};

// ── Gera PDF ──
const gerarPDF = async (pedidoId: number): Promise<boolean> => {
  try {
    const html2pdf = (await import("html2pdf.js")).default;
    const el = document.getElementById("pdf-print-area");
    if (!el) return false;

    await html2pdf()
      .set({
        margin: [0, 0, 0, 0] as [number, number, number, number],
        filename: `Pedido_${pedidoId}.pdf`,
        image: { type: "jpeg" as const, quality: 0.98 },
        html2canvas: {
          scale: 2,
          useCORS: true,
          logging: false,
          windowWidth: 794,
        },
        jsPDF: {
          unit: "mm" as const,
          format: "a4" as const,
          orientation: "portrait" as const,
        },
      })
      .from(el)
      .save();

    return true;
  } catch (err) {
    console.error("Erro PDF:", err);
    return false;
  }
};

// ── COMPONENTE ──
const AwsOrderPrintView: React.FC<AwsOrderPrintViewProps> = ({
  pedidoId,
  onClose,
  autoDownload,
}) => {
  const { token } = useAuthStore();
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [downloading, setDownloading] = useState(false);
  const [modo, setModo] = useState<"interno" | "cliente">("cliente");
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const apiURL = process.env.REACT_APP_API_URL || "";
        const res = await axios.get(`${apiURL}/api/orders/aws/${pedidoId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setData(res.data);
      } catch {
        setError("Falha ao carregar pedido.");
      } finally {
        setLoading(false);
      }
    })();
  }, [pedidoId, token]);

  const baixar = async (m: "interno" | "cliente") => {
    setModo(m);
    setDownloading(true);
    // Aguarda o React renderizar o preview com o modo correto
    await new Promise((r) => setTimeout(r, 200));
    const ok = await gerarPDF(pedidoId);
    if (!ok) alert("Erro ao gerar PDF.");
    setDownloading(false);
  };

  const ov: React.CSSProperties = {
    position: "fixed",
    inset: 0,
    zIndex: 9999,
    background: "rgba(0,0,0,0.45)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 20,
  };

  if (loading)
    return (
      <div style={ov}>
        <div
          style={s({
            background: "#fff",
            borderRadius: 12,
            padding: 40,
            textAlign: "center",
            maxWidth: 400,
            width: "100%",
          })}
        >
          Carregando...
        </div>
      </div>
    );
  if (error || !data)
    return (
      <div style={ov} onClick={onClose}>
        <div
          onClick={(e) => e.stopPropagation()}
          style={s({
            background: "#fff",
            borderRadius: 12,
            padding: 40,
            textAlign: "center",
            maxWidth: 400,
            width: "100%",
          })}
        >
          <p style={s({ color: "#c00" })}>{error || "Erro"}</p>
          <button
            onClick={onClose}
            style={s({ marginTop: 12, padding: "8px 20px" })}
          >
            Voltar
          </button>
        </div>
      </div>
    );

  const p = data.pedido;

  return (
    <>
      <div style={s({ position: "fixed", top: 0, left: 0, zIndex: 9998 })}>
        <PedidoPreview data={data} modo={modo} />
      </div>

      <div style={ov}>
        <div
          style={s({
            background: "#fff",
            borderRadius: 14,
            padding: "36px 28px",
            textAlign: "center",
            maxWidth: 440,
            width: "100%",
            boxShadow: "0 8px 30px rgba(0,0,0,0.15)",
          })}
        >
          {autoDownload ? (
            <>
              <div style={s({ fontSize: "2.5rem", marginBottom: 6 })}>✅</div>
              <h3
                style={s({
                  color: "#2e7d32",
                  margin: "0 0 6px 0",
                  fontSize: "1.2rem",
                })}
              >
                Pedido #{p.id} criado!
              </h3>
            </>
          ) : (
            <>
              <h2
                style={s({
                  margin: "0 0 6px 0",
                  fontSize: "1.2rem",
                  color: "#1B2A49",
                })}
              >
                Pedido #{p.id}
              </h2>
            </>
          )}
          <p
            style={s({
              margin: "0 0 4px 0",
              fontWeight: 600,
              fontSize: "1rem",
            })}
          >
            {p.cliente_nome}
          </p>
          <p
            style={s({
              margin: "0 0 18px 0",
              color: "#888",
              fontSize: "0.85rem",
            })}
          >
            {FD(p.data_emissao)} | {p.operacao_fiscal} | {p.condicao_pgto}
          </p>
          <div
            style={s({
              background: "#f8f9fa",
              borderRadius: 8,
              padding: 14,
              marginBottom: 20,
              textAlign: "left",
              fontSize: "0.9rem",
              color: "#555",
            })}
          >
            <p style={s({ margin: "0 0 4px 0" })}>
              <strong>Itens:</strong> {data.totalItens} pares
            </p>
            <p style={s({ margin: 0 })}>
              <strong>Valor Total:</strong> {FC(data.totalValor)}
            </p>
          </div>
          <div
            style={s({
              display: "flex",
              gap: 10,
              justifyContent: "center",
              flexWrap: "wrap",
            })}
          >
            <button
              onClick={() => baixar("cliente")}
              disabled={downloading}
              style={s({
                padding: "10px 18px",
                background: downloading ? "#999" : "#2563eb",
                color: "#fff",
                border: "none",
                borderRadius: 8,
                cursor: downloading ? "not-allowed" : "pointer",
                fontWeight: 700,
                fontSize: "0.9rem",
              })}
            >
              📥 PDF Cliente
            </button>
            <button
              onClick={() => baixar("interno")}
              disabled={downloading}
              style={s({
                padding: "10px 18px",
                background: downloading ? "#999" : "#b91c1c",
                color: "#fff",
                border: "none",
                borderRadius: 8,
                cursor: downloading ? "not-allowed" : "pointer",
                fontWeight: 700,
                fontSize: "0.9rem",
              })}
            >
              📥 PDF Interno
            </button>
            <button
              onClick={onClose}
              style={s({
                padding: "12px 28px",
                background: "#fff",
                color: "#333",
                border: "1px solid #ccc",
                borderRadius: 8,
                cursor: "pointer",
                fontWeight: 600,
                fontSize: "0.95rem",
              })}
            >
              ← {autoDownload ? "Ir para Pedidos" : "Voltar"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default AwsOrderPrintView;
